import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@mantine/core';
import { z } from 'zod';

import { TableSortButton } from 'components/shared';

import { useFormsListContext } from '../../context';

export const FormsTableHeadRow = () => {
  const { t } = useTranslation(['forms']);
  const { allFormsMassActionsSelected, toggleAllMassActionsSelected } =
    useFormsListContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const sortOrder = z
    .enum(['asc', 'desc'])
    .parse(searchParams.get('sortOrder') ?? 'desc');

  return (
    <tr>
      <th>
        <Checkbox
          sx={{ marginBottom: 0 }}
          checked={allFormsMassActionsSelected}
          onChange={toggleAllMassActionsSelected}
        />
      </th>
      <th>{t('forms:listView.tableHead.name')}</th>
      <th>{t('forms:listView.tableHead.id')}</th>
      <th>
        <TableSortButton
          text={t('forms:listView.tableHead.lastUpdate')}
          value="updated_at"
          sort={{ sortBy: 'updated_at', sortDir: sortOrder }}
          setSort={() => {
            setSearchParams(prev => ({
              ...prev,
              sortOrder: prev.get('sortOrder') === 'asc' ? 'desc' : 'asc',
            }));
          }}
        />
      </th>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <th />
    </tr>
  );
};
